import { gsap } from 'gsap'
import Cookies from 'js-cookie'
/**
 * Goal Notes:
 * - Store current/last clicked state in js cookie
 * - Sequentially animate category group on hover
 * - Change active state
 * - Animate height differences that may be needed
 */
export default class ProductsNav {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.categories = this.el.querySelector('[data-categories]')
    this.options = this.el.querySelectorAll('[data-category]')
    this.panels = this.el.querySelectorAll('[data-type]')
    this.activeBar = this.el.querySelector('[data-active-marker]')
    this.active = ''
    this.activeCls = 's-active'
    this.inactiveCls = 'hidden'
    this.activeNavCls = 'text-white'
    this.inactiveNavCls = 's-inactive'
    this.currentProductPage = window.currentProduct
  }

  init() {
    this.handleIfCurrentPage()
    this.getCookie()
    this.setActiveState()
    this.options.forEach((element) => {
      // element.addEventListener("mouseover", this.handleClick);
      element.addEventListener('click', this.handleClick)
    })
    window.addEventListener('resize', this.resize)
  }

  // if we're on a template page with window var set
  // make that the active page
  handleIfCurrentPage() {
    // if not set, return
    if (!this.currentProductPage) {
      return false
    }
    // make sure it's set to something that we can use
    const elm = this.el.querySelector(
      `[data-category="${this.currentProductPage}"]`,
    )
    if (!elm) {
      return false
    }
    this.setCookie(this.currentProductPage)
  }

  resize = () => {
    this.handleActiveBar()
  }

  handleClick = (event) => {
    event.preventDefault()
    const { currentTarget } = event
    if (this.getCookie() !== currentTarget.dataset.category) {
      this.setCookie(currentTarget.dataset.category)
      this.setActiveState()
    }
  }

  getCookie() {
    this.active = Cookies.get('product')
    if (typeof this.active === 'undefined') {
      // select first if no cookie is set
      const current = this.options[0]
      this.setCookie(current.dataset.category)
      this.active = Cookies.get('product')
    }
    return this.active
  }

  setCookie(value) {
    Cookies.set('product', value)
  }

  setActiveState() {
    this.getCookie()
    const activeNav = this.categories.querySelector(
      `[data-category=${this.active}]`,
    )
    const currentPanel = this.el.querySelector(`.${this.activeCls}`)
    // set height

    const nextPanel = this.el.querySelector(
      `[data-type=${this.active}]`,
    )
    this.options.forEach((element) => {
      element.classList.remove(this.activeNavCls)
      element.classList.add(this.inactiveNavCls)
    })
    this.panels.forEach((element) => {
      element.classList.remove(this.activeCls)
      element.classList.add(this.inactiveCls)
    })
    activeNav.classList.add(this.activeNavCls)
    nextPanel.classList.add(this.activeCls)
    nextPanel.classList.remove(this.inactiveCls)

    this.handleActiveBar()
    this.handleTransition(currentPanel, nextPanel)
  }

  handleActiveBar() {
    if (typeof this.activeBar === 'undefined') {
      return false
    }
    // find current active nav item
    const activeNav = this.categories.querySelector(`.${this.activeNavCls}`)
    const startLeft = this.activeBar.offsetLeft
    const startWidth = this.activeBar.offsetWidth
    const moveLeftTo = activeNav.offsetLeft
    const moveWidthTo = activeNav.offsetWidth

    const tl = gsap.timeline({ duration: 0.2, ease: 'back.inOut(1)' })

    tl.fromTo(
      this.activeBar,
      {
        left: startLeft,
        width: startWidth,
      },
      {
        left: moveLeftTo,
        width: moveWidthTo,
        duration: 0.3,
      },
      '<',
    )
    // console.log(moveLeftTo);
  }

  handleTransition = (current, next) => {
    const tl = gsap.timeline({
      defaults: { duration: 0.25, stagger: 0.1 },
    })
    if (current) {
      const itemsOut = current.querySelectorAll('[data-product]')
      gsap.set(itemsOut, { opacity: 1 })
      tl.to(itemsOut, {
        autoAlpha: 0,
        y: -15,
      })
    }
    if (next) {
      const itemsIn = next.querySelectorAll('[data-product]')
      gsap.set(itemsIn, { opacity: 0 })
      tl.fromTo(
        itemsIn,
        {
          autoAlpha: 0,
          y: 15,
        },
        {
          autoAlpha: 1,
          y: 0,
        },
        '<',
      )
    }
  }
}
